import { Box, Checkbox, useTheme } from "@mui/material";
import Flex from "../Flex";
import { MData } from "./types";
import { PRIMITIVE } from "../ds";

interface OptionRowProps<T extends MData> {
  option: T;
  labelKey: keyof T;
  selected: boolean;
  onToggle: (opt: T) => void;
  renderCustomLabel?: (opt: T) => React.ReactNode;
}

export const OptionRow = <T extends MData>({
  option,
  labelKey,
  selected,
  onToggle,
  renderCustomLabel,
}: OptionRowProps<T>) => {
  const theme = useTheme();
  return (
    <Flex
      alignItems="center"
      gap={1}
      onClick={(e: React.MouseEvent) => {
        e.stopPropagation();
        onToggle(option);
      }}
      sx={{
        px: 1.25,
        py: 0.75,
        cursor: "pointer",
        "&:hover": { backgroundColor: theme.palette.action.hover },
      }}
    >
      <Checkbox checked={selected} size="small" sx={{ p: 0 }} tabIndex={-1} />
      <Box
        sx={{
          fontSize: `${PRIMITIVE.typography.fontSize.body.b5}px`,
          flex: 1,
          minWidth: 0,
        }}
      >
        {renderCustomLabel
          ? renderCustomLabel(option)
          : String(option[labelKey] ?? "")}
      </Box>
    </Flex>
  );
};
